import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const batchHistoricalEventsStyles = makeStyles((theme: Theme) =>
    createStyles({
        main: {
            padding: "10px 50px 30px 50px",
        },
        subTitle: {
            color: "#525252",
            lineHeight: "120%",
            marginTop: "5px",
        },
        headerTitle: {
            color: "#525252",
            letterSpacing: "0.03em",
            textTransform: "uppercase",
            fontWeight: 500,
        },
        headerCell: {
            paddingTop: "20px",
            paddingBottom: "20px",
        },
        Id: {
            color: "#270ADC",
            cursor: "pointer",
        },
    })
);
